module.exports = __webpack_public_path__ + "static/img/c_znzz81.25d3c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c_znzz81.png
// module id = LK04
// module chunks = 73